export default __webpack_public_path__ + "static/media/KOD0084-min.55e47b6f.webp";